// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-add-existing-fields__container .modal2__container {
    width: 40%;
}

.tournament-add-existing-fields__chk-list {
    padding: 36px;
}

.tournament-add-existing-fields__text.baloa-table {
    color: var(--primary-very-dark-color);
    margin-bottom: 18px;
}

.tournament-add-existing-fields__field {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 14px;
}

.tournament-add-existing-fields__field-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tournament-add-existing-fields__field {
    padding: 10px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 6px;
}

input.tournament-add-existing-fields__field-input {
    margin: 0;
    height: 22px;
    width: 22px;
    border-radius: 4px;
}

input.tournament-add-existing-fields__field-input[type="checkbox"]:checked:before {
    border-color: var(--white-color);
    background: var(--new-green-color);
    border: none;
    border-radius: 4px;
    height: 22px;
    width: 22px;
}

input.tournament-add-existing-fields__field-input[type="checkbox"]:before {
    content: "";
    width: 22px;
    height: 22px;
    border: 3px solid var(--new-gray-color);
    border-radius: 4px;
    background: var(--white-color);
}

input.tournament-add-existing-fields__field-input[type="checkbox"]:checked:after {
    content: "";
    width: 11px;
    height: 6px;
    border: 3px solid var(--white-color);
    float: left;
    margin-left: 5px;
    border-right: 0;
    border-top: 0;
    margin-top: -15px;
    transform: rotate(-55deg);
}

.tournament-add-existing-fields__actions {
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    border-top: 1px solid var(--new-input-background-color);
}

.tournament-add-existing-fields__actions .primary-button {
    padding: 10px 16px;
    font-size: 16px;
    line-height: 19px;
}

`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-add-existing-fields-modal/TournamentAddExistingFieldsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".tournament-add-existing-fields__container .modal2__container {\n    width: 40%;\n}\n\n.tournament-add-existing-fields__chk-list {\n    padding: 36px;\n}\n\n.tournament-add-existing-fields__text.baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 18px;\n}\n\n.tournament-add-existing-fields__field {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    margin-bottom: 14px;\n}\n\n.tournament-add-existing-fields__field-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.tournament-add-existing-fields__field {\n    padding: 10px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 6px;\n}\n\ninput.tournament-add-existing-fields__field-input {\n    margin: 0;\n    height: 22px;\n    width: 22px;\n    border-radius: 4px;\n}\n\ninput.tournament-add-existing-fields__field-input[type=\"checkbox\"]:checked:before {\n    border-color: var(--white-color);\n    background: var(--new-green-color);\n    border: none;\n    border-radius: 4px;\n    height: 22px;\n    width: 22px;\n}\n\ninput.tournament-add-existing-fields__field-input[type=\"checkbox\"]:before {\n    content: \"\";\n    width: 22px;\n    height: 22px;\n    border: 3px solid var(--new-gray-color);\n    border-radius: 4px;\n    background: var(--white-color);\n}\n\ninput.tournament-add-existing-fields__field-input[type=\"checkbox\"]:checked:after {\n    content: \"\";\n    width: 11px;\n    height: 6px;\n    border: 3px solid var(--white-color);\n    float: left;\n    margin-left: 5px;\n    border-right: 0;\n    border-top: 0;\n    margin-top: -15px;\n    transform: rotate(-55deg);\n}\n\n.tournament-add-existing-fields__actions {\n    display: flex;\n    justify-content: flex-end;\n    padding: 16px;\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.tournament-add-existing-fields__actions .primary-button {\n    padding: 10px 16px;\n    font-size: 16px;\n    line-height: 19px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
